import AbstractFieldsValidator from 'components/helpers/validation/AbstractFieldsValidator';
import {isValidNumber} from 'libphonenumber-js';
import validateAlphaNumeric from '../../helpers/validation/validateAlphaNumeric';

export default function (fields, options) {
    return new DoctorDocumentFieldsValidator(fields, options).validate();
}

class DoctorDocumentFieldsValidator extends AbstractFieldsValidator {
    doCheckForSingleValue() {
        const {
            phoneNumber,
            homePhoneNumber,
            faxNumber,
            deaNumber,
            npiNumber,
            signature,
            cv,
            deaNumberValue,
            npiNumberValue,
            homeZip,
            workZip,
        } = this.fields;

        if (!phoneNumber || !phoneNumber.trim()) {
            this.addError('phoneNumber', loc('phoneNumber-empty'));
        } else if (!isValidNumber(phoneNumber) && !isValidNumber(phoneNumber, 'US')) {
            this.addError('phoneNumber', loc('phoneNumber-invalid'));
        }

        if (!faxNumber || !faxNumber.trim()) {
            this.addError('faxNumber', loc('faxNumber-empty'));
        } else if (!isValidNumber(faxNumber) && !isValidNumber(faxNumber, 'US')) {
            this.addError('faxNumber', loc('faxNumber-invalid'));
        }

        if (homePhoneNumber && !isValidNumber(homePhoneNumber) && !isValidNumber(homePhoneNumber, 'US')) this.addError('homePhoneNumber', 'Please type valid tel');

        if (!deaNumber) {
            this.addError('deaNumber', 'Please select an answer');
        }

        if (deaNumber && deaNumber === 'yes-label') {
            if (!deaNumberValue) {
                this.addError('deaNumberValue', loc('deaNumber-empty'));
            } else if (!validateAlphaNumeric(deaNumberValue)) {
                this.addError('deaNumberValue', loc('deaNumber-invalid'));
            }
        }


        if (!npiNumber) {
            this.addError('npiNumber', 'Please select an answer');
        }

        if (npiNumber && npiNumber === 'yes-label') {
            if (!npiNumberValue) {
                this.addError('npiNumberValue', loc('npiNumber-empty'));
            } else if (!validateAlphaNumeric(npiNumberValue)) {
                this.addError('npiNumberValue', loc('npiNumber-invalid'));
            }
        }

        if (!signature) this.addError('signature', 'Please sign the registration form');

        if (homeZip && !/\d{5}/.test(homeZip)) {
            this.addError('homeZip', loc('invalid-zip'));
        }

        if (workZip && !/^[0-9]{5}/.test(workZip)) {
            this.addError('workZip', loc('invalid-zip'));
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/validateDoctorDocumentFields.js